// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled-icon[data-v-630e5b1a]{color:grey;-webkit-filter:grayscale(100%);filter:grayscale(100%)}.fw-normal[data-v-630e5b1a]{font-weight:400}", ""]);
// Exports
module.exports = exports;
